import { render, staticRenderFns } from "./vFormRender_dialog.vue?vue&type=template&id=b2e2ddfc&scoped=true&lang=pug"
import script from "./vFormRender_dialog.vue?vue&type=script&lang=js"
export * from "./vFormRender_dialog.vue?vue&type=script&lang=js"
import style0 from "./vFormRender_dialog.vue?vue&type=style&index=0&id=b2e2ddfc&prod&lang=scss&scoped=true"
import style1 from "./vFormRender_dialog.vue?vue&type=style&index=1&id=b2e2ddfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e2ddfc",
  null
  
)

export default component.exports